import React from 'react';
import styles from './lineSeparator.module.scss';

const LineSeparator: React.FC = () => <div className={styles.lineSeparator} />;

export default LineSeparator;
